import { pos365Service } from 'services';
import {
  ICategory,
  IGetRoomInfoResponse,
  IProduct,
  ISaveOrderItemInfo,
} from 'interfaces';

const usePos365 = () => {
  const getCategories = async (
    retailerCode: string
  ): Promise<ICategory[] | null> => {
    try {
      const res = await pos365Service.getCategory({ retailerCode });
      return res.items;
    } catch (e) {
      return null;
    }
  };

  const getProductByCategoryId = async (
    retailerCode: string,
    categoryId?: number
  ): Promise<IProduct[] | null> => {
    try {
      const res = await pos365Service.getProduct({
        retailerCode,
        ...(!!categoryId ? { categoryId } : {}),
      });
      return res.items;
    } catch (e) {
      return null;
    }
  };

  const getRoomInfo = async (
    roomCode: string
  ): Promise<IGetRoomInfoResponse | null> => {
    try {
      return await pos365Service.getRoomInfo({ roomCode });
    } catch (e) {
      return null;
    }
  };

  const saveOrder = async (
    roomCode: string,
    items: ISaveOrderItemInfo[]
  ): Promise<void> => {
    await pos365Service.saveOrder({ roomCode, items });
  };

  return {
    getCategories,
    getProductByCategoryId,
    getRoomInfo,
    saveOrder,
  };
};

export default {
  usePos365,
};
